import { supertypeClass, property, Supertype, Persistable, Remoteable } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { Policy } from './Policy';
import { DocTypes } from '../static/Assumptions';

export interface ESignDocMetadataType {
  numberOfPages: number;
  numberOfSignatures: number;
  signedFromIP: string;
  generatedByIP: string;
  eSignStartTime: string;
  securityType: string;
  typeOfApplication: string;
  signedAt: Date;
  signedAtTimeStamp: string;
}

@supertypeClass({ toClient: true, toServer: true })
export class ESignDocMetadata extends Remoteable(Persistable(Supertype)) {
  @property({
    comment: 'Number of pages of the document that was generated for eSigning',
  })
  numberOfPages: number;

  @property({
    comment: 'Number of signatures needed in the document that was generated for eSigning',
  })
  numberOfSignatures: number;

  @property({
    getType: () => Policy,
    comment: 'Attach to policy to get ESign doc details',
  })
  applicationPolicy: Policy;

  @property({
    comment: 'Source or ip Address of the machine the document was generated from',
    toClient: false,
  })
  generatedBy: string;

  @property({
    comment: 'Source or ip Address of the machine the document was signed with',
    toClient: false,
  })
  eSignedFrom: string;

  @property({
    comment: 'Type of the document for which the metadata is stored',
  })
  docType: DocTypes;

  @property({
    comment: 'Session id of the session with which customer was on ESign stage',
  })
  sessionId: string;

  @property({
    comment: 'Date at which user signed the document',
  })
  signedAt: Date;

  @property({
    comment: 'TimeStamp at which user signed the document, exact text that appears on document',
  })
  signedAtTimeStamp: string;

  @property({
    comment: 'TimeStamp at which the document was generated, exact text that appears on document for eSign certificate',
  })
  generatedAtTimeStamp: string;

  @property({ persist: false })
  securityType: string = 'Account Authenticated';

  @property({ persist: false })
  typeOfApplication: string = 'Life Insurance Application';

  static new(docType: DocTypes, policy: Policy): ESignDocMetadata {
    return new ESignDocMetadata().init(docType, policy);
  }

  getMetadata(): ESignDocMetadataType {
    return {
      numberOfPages: this.numberOfPages,
      numberOfSignatures: this.numberOfSignatures,
      signedFromIP: this.eSignedFrom,
      generatedByIP: this.generatedBy,
      eSignStartTime: this.generatedAtTimeStamp,
      securityType: this.securityType,
      typeOfApplication: this.typeOfApplication,
      signedAt: this.signedAt,
      signedAtTimeStamp: this.signedAtTimeStamp,
    };
  }

  init(docType: DocTypes, policy: Policy): this {
    this.docType = docType;
    this.applicationPolicy = policy;
    return this;
  }
}
